import React, {useMemo} from 'react';
import {GtaRate, GtaRateStatusEnum} from "@/Stub/V1";
import {useGetGtaRatesInfinite} from "@/Service/Api/V1/ApiHooks/GtaRates/useGetGtaRatesInfinite";
import useLastOptionElementRef from "@/Hooks/useLastOptionElementRef";
import BaseDropdown, {BaseDropdownProps} from "@/Components/Forms/Form/BaseDropdown";

export type GtaRateSelectProps = BaseDropdownProps & {
    gtaRateId?: number,
    selectedGtaRate?: GtaRate
};

const GtaRateSelect: React.FC<GtaRateSelectProps> = ({gtaRateId, selectedGtaRate, ...props}) => {
    const {
        data,
        isLoading,
        fetchNextPage,
        hasNextPage,
    } = useGetGtaRatesInfinite({
        requestParams: {
            status: GtaRateStatusEnum.Active,
            per_page: 200,
        }
    });

    const items = useMemo(() => {
        let gtaRateList = data?.pages?.flatMap((page) => page.data) ?? [];
        if (selectedGtaRate && !gtaRateList.some(item => item.id === selectedGtaRate.id)) {
            gtaRateList = [selectedGtaRate, ...gtaRateList];
        }
        return gtaRateList;
    }, [data, selectedGtaRate]);

    const {lastOptionElementRef} = useLastOptionElementRef({fetchNextPage: fetchNextPage, hasNextPage: hasNextPage});

    const optionTemplate = (option: GtaRate) => {
        return (
            <div ref={items[items.length - 1].id === option.id ? lastOptionElementRef : null}
                 className="flex align-items-center">
                <p>
                    {option.gta_group}
                </p>
            </div>
        );
    };


    return (
        <BaseDropdown
            options={items}
            optionValue="id"
            optionLabel="gta_group"
            showClear
            onClick={(e) => {
                if (props.onClick) {
                    props.onClick(e);
                }
            }}
            itemTemplate={optionTemplate}
            loading={isLoading}
            {...props}
        />
    );
};

export default GtaRateSelect;
